import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { PressMentionsSectionItemData } from '@superfunnel/types';
import Button from '@superfunnel/ui-core/v2/Button';

interface IPressMentions {
  pressMentions?: PressMentionsSectionItemData[];
  onEditClick: (pressMention: PressMentionsSectionItemData) => void;
  onDeleteClick: (pressMention: PressMentionsSectionItemData) => void;
}
export const PressMentions = ({
  pressMentions,
  onEditClick,
  onDeleteClick,
}: IPressMentions) => {
  if (!pressMentions?.length) {
    return <div className="text-base-500 font-inter text-sm/[1]">None</div>;
  }
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row flex-wrap gap-4">
        {pressMentions?.map((pressMention) => (
          <div key={pressMention.id} className="group relative">
            <PressMention pressMention={pressMention} />
            <div className="invisible absolute top-0 flex h-full w-full items-start justify-end group-hover:visible">
              <Button
                size="icon-sm"
                onClick={() => onEditClick(pressMention)}
                className="absolute -top-2 -right-2"
              >
                <PencilIcon className="h-4 w-4" />
              </Button>
              <Button
                size="icon-sm"
                color="negative"
                onClick={() => onDeleteClick(pressMention)}
                className="absolute top-6 -right-2"
              >
                <TrashIcon className="h-4 w-4" />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

function PressMention({
  pressMention,
}: {
  pressMention: PressMentionsSectionItemData;
}) {
  return (
    <figure className="rounded-2xl bg-white shadow-lg ring-1 ring-gray-900/5 sm:col-span-2 xl:col-start-2 xl:row-end-1">
      <blockquote className="text max-w-md min-w-[300px] p-6 leading-6 font-semibold tracking-tight text-gray-900 sm:p-8 sm:leading-8">
        <p>{`“${pressMention.body}”`}</p>
      </blockquote>
      {pressMention.name ? (
        <div className="flex flex-wrap items-center px-6 pb-6 sm:flex-nowrap sm:px-8">
          <div className="flex-auto">
            <div className="font-semibold">
              {`${pressMention?.name || 'Anonymous'}`}
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      {pressMention.logo ? (
        <figcaption className="flex flex-wrap items-center gap-x-4 gap-y-4 border-t border-gray-900/10 px-6 py-4 sm:flex-nowrap">
          <img
            className="h-10 w-auto flex-none"
            src={pressMention?.logo?.url}
            alt=""
          />
        </figcaption>
      ) : (
        <></>
      )}
    </figure>
  );
}
